import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import CustomerSearch from './CustomerSearch'
import { selectIsTablet } from '../../../layout/state/selector'
import { selectIsPartner } from '../../../security/state/auth/selector'


const mapStateToProps = state => {
    return {
        tableData: selector.tableSelectorEmployee(state),
        isTablet: selectIsTablet(state),
        isPartner: selectIsPartner(state),
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryEmployee,
    initialTableSettings: action.initialTableSettings,
    toggleColumnVisibility: action.toggleColumnVisibility,
    changeFilter: action.changeFilterEmployee,
    toggleSort: action.toggleSortEmployee,
    toggleMultiSort: action.toggleMultiSortEmployee,
    gotoPage: action.gotoPageEmployee,
    navigateToCustomer: (customerId) => {
        return push('/customer/edit/' + customerId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(CustomerSearch)



// WEBPACK FOOTER //
// ./src/modules/customer/component/search/CustomerSearchContainer.js